export default __webpack_public_path__ + "static/media/menshealth.a63b3092.png";